import { AI } from "../apis/ws_api";
import { processAIRandomness, processProportionDictionary } from "../utils";
import * as React from "react";
import { useState } from "react";

export function AISelection(props: { addAI: (x: AI) => void }) {
    const [aiRandomness, setAIRandomness] = useState<number>(6);
    const [proportionDictionary, setProportionDictionary] = useState<number>(7);

    return (
        <div className="ai-selection">
            <div className="ai-grid">
                <label htmlFor="proportion-dictionary">
                    AI's proportion of dictionary:
                </label>
                <input
                    type="number"
                    name="proportion-dictionary"
                    value={proportionDictionary}
                    onInput={(e) => {
                        setProportionDictionary(e.currentTarget.valueAsNumber);
                    }}
                    min={1}
                    max={100}
                />
                <label htmlFor="randomness">Level of randomness in AI:</label>
                <input
                    type="number"
                    name="randomness"
                    value={aiRandomness}
                    onInput={(e) => {
                        setAIRandomness(e.currentTarget.valueAsNumber);
                    }}
                    min={0}
                    max={100}
                />
            </div>
            <details>
                <ul>
                    <li>
                        "AI's proportion of dictionary" controls what percent of
                        the total AI dictionary the AI can form words with. At
                        100%, it has access to its entire dictionary - although
                        this dictionary is still less than what the player has
                        access to.
                    </li>
                    <li>
                        <div>
                            "Level of randomness in AI" controls the degree to
                            which the AI picks the optimal move for each of its
                            turns. At 0, it always picks the highest scoring
                            move it can do using the dictionary it has access
                            to. At 1, it picks from its available moves at
                            random.
                        </div>
                        <div>
                            Note that "Level of randomness in AI" is now mapped
                            on a log scale. Your current setting is equivalent
                            to{" "}
                            {(100 * processAIRandomness(aiRandomness)).toFixed(
                                1,
                            )}
                            % on the previous scale.
                        </div>
                    </li>
                </ul>
            </details>
            <button
                onClick={() => {
                    const ai: AI = {
                        proportion:
                            processProportionDictionary(proportionDictionary),
                        randomness: processAIRandomness(aiRandomness),
                    };
                    props.addAI(ai);
                }}
            >
                Add AI
            </button>
        </div>
    );
}
